import React, {useState} from "react";
import BlockButton from "../components/block-button";
import UnderlineButton from "../components/underline-button";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import { inquireWatchMsisdn, submitSwapOrder, submitWatchOrder } from "../services/pairing-service";
import {CreateWatchOrderResponse, planState,} from "../states/plan-state/plan-atoms";
import {OperationResult} from "../models/operation-result";
import {useRecoilValue} from "recoil";
import {ThreeDots} from "react-loader-spinner";
import {GenericResponse} from "../models/generic-response";
import { Flow } from "../models/flow-enum";
const TermsAndConditions = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const {
    createWatchOrderResponse,
    selectedAutoCompleteAddressObject,
    selectedAddressFromForm,
    serviceAddress,
    inquireCompanionFlowResponse,
    customerOrderId,
    emergencyAddress,
  } = useRecoilValue(planState);
  const [loading, setLoading] = useState(false);

  const continueClick = () => {
    setLoading(true);
    if (!!createWatchOrderResponse?.pairAccountId) {
      submitSwapOrder(
        selectedAutoCompleteAddressObject?.addrId
          ? {
            ...createWatchOrderResponse,
            capturedAddress: {
              ...selectedAutoCompleteAddressObject,
              updated: localStorage.getItem("isChangedAddress") === "1",
              tmoBillAccountId: createWatchOrderResponse?.tmoBillingAccountId,
              watchAccountIds:
              createWatchOrderResponse?.capturedAddress?.watchAccountIds,
            },
            watchInfo: localStorage.getItem("watchInfo")
              ? JSON.parse(localStorage.getItem("watchInfo")!)
              : {},
          }
          : selectedAddressFromForm?.addrDesc
            ? {
              ...createWatchOrderResponse,
              capturedAddress: {
                ...selectedAddressFromForm,
                updated: localStorage.getItem("isChangedAddress") === "1",
                tmoBillAccountId:
                createWatchOrderResponse?.tmoBillingAccountId,
                watchAccountIds:
                createWatchOrderResponse?.capturedAddress?.watchAccountIds,
              },
              watchInfo: localStorage.getItem("watchInfo")
                ? JSON.parse(localStorage.getItem("watchInfo")!)
                : {},
            }
            : {
            ...createWatchOrderResponse,
            capturedAddress: {
              ...emergencyAddress,
              updated: localStorage.getItem("isChangedAddress") === "1",
              tmoBillAccountId:
              createWatchOrderResponse?.tmoBillingAccountId,
              watchAccountIds:
              createWatchOrderResponse?.capturedAddress?.watchAccountIds,
            },
            watchInfo: localStorage.getItem("watchInfo")
              ? JSON.parse(localStorage.getItem("watchInfo")!)
              : {},
          } || ({} as CreateWatchOrderResponse),
      )
        .then((response: OperationResult) => {
          if (response.resultCode === "SUCCESS") {
            setLoading(false);
            navigate("/confirmation");
          }
          else {
            navigate('/error');
          }
        })
        .catch((error: any) => {
          setLoading(false);
          navigate('/error');
        });
    } else {
      if(createWatchOrderResponse?.capturedAddress?.addrDesc && !emergencyAddress?.addrDesc && !serviceAddress?.addrDesc && inquireCompanionFlowResponse?.nextFlowPage !== Flow.SINGLE_DEVICE_PAIRED) {
        submitWatchOrder(
          selectedAutoCompleteAddressObject?.addrId
            ? {
              ...createWatchOrderResponse,
              capturedAddress: {
                ...selectedAutoCompleteAddressObject,
                updated: localStorage.getItem("isChangedAddress") === "1",
                tmoBillAccountId: createWatchOrderResponse?.tmoBillingAccountId,
                watchAccountIds:
                createWatchOrderResponse?.capturedAddress?.watchAccountIds,
              },
              watchInfo: localStorage.getItem("watchInfo")
                ? JSON.parse(localStorage.getItem("watchInfo")!)
                : {},
            }
            : selectedAddressFromForm?.addrDesc
              ? {
                ...createWatchOrderResponse,
                capturedAddress: {
                  ...selectedAddressFromForm,
                  updated: localStorage.getItem("isChangedAddress") === "1",
                  tmoBillAccountId:
                  createWatchOrderResponse?.tmoBillingAccountId,
                  watchAccountIds:
                  createWatchOrderResponse?.capturedAddress?.watchAccountIds,
                },
                watchInfo: localStorage.getItem("watchInfo")
                  ? JSON.parse(localStorage.getItem("watchInfo")!)
                  : {},
              }
              : {
              ...createWatchOrderResponse,
              capturedAddress: {
                ...createWatchOrderResponse.capturedAddress,
                updated: localStorage.getItem("isChangedAddress") === "1",
                tmoBillAccountId:
                createWatchOrderResponse?.tmoBillingAccountId,
                watchAccountIds:
                createWatchOrderResponse?.capturedAddress?.watchAccountIds,
              },
              watchInfo: localStorage.getItem("watchInfo")
                ? JSON.parse(localStorage.getItem("watchInfo")!)
                : {},
            } || ({} as CreateWatchOrderResponse),
        )
          .then((response: GenericResponse<any>) => {
            if (response.operationResult.resultCode === "SUCCESS") {
              // @ts-ignore
              const dataActivationController = DataActivationController;
              if (dataActivationController) {
                // @ts-ignore
                dataActivationController.dataPlanPendingRelease();
                dataActivationController.hideCancelButtonSelected();
                setLoading(false);
                navigate("/confirmation");
              } else {
                setLoading(false);
                navigate("/confirmation");
                console.warn("DataActivationController not found");
              }

            }
            else {
              setLoading(false);
              navigate('/error');
            }
          })
          .catch((error: any) => {
            setLoading(false);
            navigate('/confirmation');
          });
      }
      else {
        inquireWatchMsisdn({
          serviceAddress: serviceAddress,
          customerId: inquireCompanionFlowResponse.customerId,
          customerOrderId: customerOrderId,
          accountId: inquireCompanionFlowResponse.tmoBillingAccountId
        }).then(result => {
          if(result.resultCode === "SUCCESS") {
            submitWatchOrder(
              selectedAutoCompleteAddressObject?.addrId
                ? {
                  ...createWatchOrderResponse,
                  capturedAddress: {
                    ...selectedAutoCompleteAddressObject,
                    updated: localStorage.getItem("isChangedAddress") === "1",
                    tmoBillAccountId: createWatchOrderResponse?.tmoBillingAccountId,
                    watchAccountIds:
                    createWatchOrderResponse?.capturedAddress?.watchAccountIds,
                  },
                  watchInfo: localStorage.getItem("watchInfo")
                    ? JSON.parse(localStorage.getItem("watchInfo")!)
                    : {},
                }
                : selectedAddressFromForm?.addrDesc
                  ? {
                    ...createWatchOrderResponse,
                    capturedAddress: {
                      ...selectedAddressFromForm,
                      updated: localStorage.getItem("isChangedAddress") === "1",
                      tmoBillAccountId:
                      createWatchOrderResponse?.tmoBillingAccountId,
                      watchAccountIds:
                      createWatchOrderResponse?.capturedAddress?.watchAccountIds,
                    },
                    watchInfo: localStorage.getItem("watchInfo")
                      ? JSON.parse(localStorage.getItem("watchInfo")!)
                      : {},
                  }
                  : {
                  ...createWatchOrderResponse,
                  capturedAddress: {
                    ...createWatchOrderResponse.capturedAddress,
                    updated: localStorage.getItem("isChangedAddress") === "1",
                    tmoBillAccountId:
                    createWatchOrderResponse?.tmoBillingAccountId,
                    watchAccountIds:
                    createWatchOrderResponse?.capturedAddress?.watchAccountIds,
                  },
                  watchInfo: localStorage.getItem("watchInfo")
                    ? JSON.parse(localStorage.getItem("watchInfo")!)
                    : {},
                } || ({} as CreateWatchOrderResponse),
            )
              .then((response: GenericResponse<any>) => {
                if (response.operationResult.resultCode === "SUCCESS") {
                  navigate("/confirmation");
                } else {
                  setLoading(false);
                  navigate("/confirmation");
                  console.warn("DataActivationController not found");
                }
              })
              .catch((error: any) => {
                setLoading(false);
                navigate('/error');
              });
          }
          else {
            setLoading(false);
            navigate('/error');
          }
        })
      }


    }
  };

  const navigateUrl = (): void => {
    window.location.href = i18n.language.startsWith("en")
      ? process.env.REACT_APP_TERMS_URL_EN || ""
      : process.env.REACT_APP_TERMS_URL_FR || "";
  };

  const onBack = () => {
    navigate("/register-address");
  };
  return loading ? (
    <ThreeDots
      visible={true}
      height="80"
      width="80"
      color="#FFD200"
      radius="9"
      ariaLabel="three-dots-loading"
      wrapperClass="full-layout"
    />
  ) : (
    <div className="layout-default">
      <h2 className="layout-default-left watch-title">{t("termsTitle")}</h2>

      <div className="box-border">
        <p dangerouslySetInnerHTML={{ __html: t("termsConditionText") }}></p>
      </div>

      <p>
        <b>
          {t("acceptInfo")}{" "}
          <span onClick={navigateUrl} className="underline">
            {t("hereText")}
          </span>
        </b>
      </p>
      <BlockButton
        onClick={continueClick}
        dataTestId="accept-button"
        text={t("acceptButton")}
      />
      <UnderlineButton
        click={onBack}
        dataTestId="back-button"
        text={t("backButton")}
      />
    </div>
  );
};

export default TermsAndConditions;
